import React from 'react';
import IcoMoon from 'react-icomoon';
import PropTypes from 'prop-types';

import { countryCodes } from 'data/countryCodes';
const iconSet = require('data/flags.json');

const IconCountry = ({ country, ...props }) => {
  if (country && (country.length === 2 || country.length === 3)) {
    const flag = countryCodes.find(({ code }) => code === country).flag;
    return <IcoMoon iconSet={iconSet} icon={flag} {...props} />;
  } else {
    return null;
  }
};

IconCountry.propTypes = {
  country: PropTypes.string
};

export default IconCountry;
